var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox-container"},[_c('input',{staticClass:"input",attrs:{"id":_vm.id,"type":"checkbox"},domProps:{"checked":_vm.value},on:{"input":_vm.updateInput}}),_c('div',{staticClass:"checkmark"}),_c('label',{staticClass:"label",attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }